export const AdminRoles = {
  Super: "Super Admin",
  Admin: "Admin",
  Moderator: "Moderator"
};
